import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  groups: Identifiable<Group>[];
  retrieveResourceGroups(
    request: Boundaries["retrieveResourceGroups"]["request"],
  ): void;
}

function useRetrieveResourceGroups(namespace: string): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveResourceGroupsRequestPending(namespace),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveResourceGroupsRequestSuccess(namespace),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveResourceGroupsRequestFailure(namespace),
    ),
    groups: useSelector(() => selector.getResourceGroups(namespace)),
    retrieveResourceGroups: core.retrieveResourceGroups,
  };
}

export { useRetrieveResourceGroups };
